import { findAll } from "../utils/dom";

const DataAtual = () =>{
	const datas = findAll("[js-data-atual]");
	if(!datas) return;

	datas.forEach((data)=>{
		const atualData = new Date();
		data.innerText = atualData.getFullYear();
	})
}

export default DataAtual;